import { Rest } from './v3/Rest';

export * as V3Types from './v3/data-contracts';

export * from './interfaces';

export const Version3Client = Rest;

export default Rest;
